export default class StringUtils {

  static normalize(value: string) {
    return value.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '').toLowerCase();
  }

  static includes(text: string, valueToTest: string): boolean {
    return text.indexOf(valueToTest) >= 0;
  }

  static generateUniqueId() {
    return String(crypto.getRandomValues(new Uint32Array(1))[0]);
  }

  static removeSpecialCharacteres(value: string) {
    return value.replace(/[^\w\s ]|[ ]/gi, '');
  }

}
